import { render } from "./IconTimeTable.vue?vue&type=template&id=53527adc"
import script from "./IconTimeTable.vue?vue&type=script&lang=ts"
export * from "./IconTimeTable.vue?vue&type=script&lang=ts"
script.render = render

export default script